import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPurchaseOrderStatus implements BaseEnumType {
  private static allValues: EnumPurchaseOrderStatus[] = []; // make sure this is top-most
  
  public static open = new EnumPurchaseOrderStatus(0, "Open", "enum_purchase_order_status_open");
  public static awaitingConfirmation = new EnumPurchaseOrderStatus(1, "AwaitingConfirmation", "enum_purchase_order_status_awaiting_confirmation");
  public static awaitingCompletion = new EnumPurchaseOrderStatus(2, "AwaitingCompletion", "enum_purchase_order_status_awaiting_completion");
  public static complete = new EnumPurchaseOrderStatus(3, "Complete", "enum_purchase_order_status_complete");
  public static posting = new EnumPurchaseOrderStatus(4, "Posting", "enum_purchase_order_status_posting");
  public static historic = new EnumPurchaseOrderStatus(5, "Historic", "enum_purchase_order_status_historic");
  public static cancelled = new EnumPurchaseOrderStatus(6, "Cancelled", "enum_purchase_order_status_cancelled");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPurchaseOrderStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOpen() { return this === EnumPurchaseOrderStatus.open; }
  public isAwaitingConfirmation() { return this === EnumPurchaseOrderStatus.awaitingConfirmation; }
  public isAwaitingCompletion() { return this === EnumPurchaseOrderStatus.awaitingCompletion; }
  public isComplete() { return this === EnumPurchaseOrderStatus.complete; }
  public isPosting() { return this === EnumPurchaseOrderStatus.posting; }
  public isHistoric() { return this === EnumPurchaseOrderStatus.historic; }
  public isCancelled() { return this === EnumPurchaseOrderStatus.cancelled; }

  public static getValues(): readonly EnumPurchaseOrderStatus[] {
    return EnumPurchaseOrderStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumPurchaseOrderStatus[] {
    return EnumPurchaseOrderStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPurchaseOrderStatus {
    const found = EnumPurchaseOrderStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPurchaseOrderStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPurchaseOrderStatus): EnumPurchaseOrderStatus {
    const found = name ? EnumPurchaseOrderStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPurchaseOrderStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPurchaseOrderStatus>): boolean {
    return this.key === other?.key;
  }
}